const env = process.env.NODE_ENV
const prod = ''
const dev = ''
export default target => (env === 'production' ? prod : dev) + target
